<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<el-form :inline="true" :model="formInline" ref="searchForm">
					<el-form-item label="IMEI" prop="imei">
						<el-input v-model="formInline.imei" placeholder="请输入IMEI" clearable style="width:180px"></el-input>
					</el-form-item>
					<el-form-item label="状态" prop="status">
						<el-select v-model="formInline.status" placeholder="请选择" clearable style="width:140px">
							<el-option label="成功" value="1"></el-option>
							<el-option label="失败" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间" prop="timeRange">
						<el-date-picker
							v-model="formInline.timeRange"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							value-format="YYYY-MM-DD HH:mm:ss"
							style="width:360px"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">{{ $t('device.inquire') }}</el-button>
						<el-button @click="reset">{{ $t('device.reset') }}</el-button>
					</el-form-item>
				</el-form>
			</template>

			<el-table :data="list" border stripe style="width:100%">
				<el-table-column label="IMEI" prop="imei" width="160"></el-table-column>
				<el-table-column label="状态" prop="status" width="100">
					<template #default="scope">
						<el-tag :type="scope.row.status == 2 ? 'danger' : 'success'" size="small">
							{{ scope.row.status == 2 ? '失败' : '成功' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="数据X" prop="data_x" width="140"></el-table-column>
				<el-table-column label="数据Y" prop="data_y" width="140"></el-table-column>
				<el-table-column label="数据Z" prop="data_z" width="140"></el-table-column>
				<el-table-column label="X坐标" prop="x" width="140"></el-table-column>
				<el-table-column label="Y坐标" prop="y" width="140"></el-table-column>
				<el-table-column label="Z坐标" prop="z" width="140"></el-table-column>
				<el-table-column label="上报数据" prop="data" min-width="240" show-overflow-tooltip>
					<template #default="scope">
						<span class="log-content">
							<span>{{ truncate(scope.row.data) }}</span>
							<el-button type="primary" size="small" @click="viewContent(scope.row.data, '上报数据')">查看</el-button>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="位置描述" prop="desc" min-width="240" show-overflow-tooltip>
					<template #default="scope">
						<span class="log-content">
							<span>{{ truncate(scope.row.desc) }}</span>
							<el-button type="primary" size="small" @click="viewContent(scope.row.desc, '位置描述')">查看</el-button>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="时间" prop="create_at" width="180"></el-table-column>
			</el-table>

			<el-dialog :title="dialogTitle" v-model="dialogVisible" width="600px" center>
				<el-input type="textarea" :rows="15" v-model="dialogContent" readonly></el-input>
			</el-dialog>

			<el-pagination
				:page-size="formInline.size"
				:page-sizes="[20, 50, 100, 200]"
				:total="total"
				:current-page="formInline.page"
				@current-change="handlePageChange"
				@size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper"
				style="margin-top:12px"
			></el-pagination>
		</el-card>
	</div>
</template>

<script>
import locationLog from '../../model/locationLog'

export default {
	name: 'LocationLog',
	data() {
		return {
			formInline: {
				imei: '',
				status: '',
				timeRange: [],
				page: 1,
				size: 20,
			},
			list: [],
			total: 0,
			dialogVisible: false,
			dialogTitle: '',
			dialogContent: '',
		}
	},
	mounted() {
		this.fetchList()
	},
	methods: {
		async fetchList() {
			const [start_time, end_time] = this.formInline.timeRange || []
			const ret = await locationLog.list({
				imei: this.formInline.imei,
				status: this.formInline.status,
				start_time: start_time || '',
				end_time: end_time || '',
				page: this.formInline.page,
				size: this.formInline.size,
			})
			if (ret.code === 200) {
				this.list = ret.data.list
				this.total = ret.data.count
			}
		},
		search() {
			this.formInline.page = 1
			this.fetchList()
		},
		reset() {
			this.$refs.searchForm.resetFields()
			this.formInline.timeRange = []
			this.formInline.page = 1
			this.fetchList()
		},
		handlePageChange(page) {
			this.formInline.page = page
			this.fetchList()
		},
		handleSizeChange(size) {
			this.formInline.size = size
			this.formInline.page = 1
			this.fetchList()
		},
		truncate(val) {
			const str = val == null ? '' : String(val)
			return str.length > 200 ? str.slice(0, 200) + '...' : str
		},
		viewContent(content, title) {
			this.dialogContent = content == null ? '' : String(content)
			this.dialogTitle = title
			this.dialogVisible = true
		},
	},
}
</script>
<style scoped>
.log-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.log-content > span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
.log-content .el-button {
  flex-shrink: 0;
}
</style>
